<template>
  <div class="bodyback-light pages">
    <notifications></notifications>
    <navmenu></navmenu>

    <div class="container pb-0 pt-md-5 pt-sm-5 pt-5">
      <div class="row justify-content-center">
        <div class="col-xl-4 col-lg-7 forms card-alerts">
          <div class="text-center custom-col">
            <h1 class="title-view-2 mb-1">Hello</h1>
            <div class="textInHorizontalLine">
              <span>{{ supplierName }}</span>
            </div>
          </div>
          <div class="card mb-3 mt-4 mb-2 pb-4">
            <div class="col-12 text-center">
              <div class="mb-2">
                <i class="title-view text-success flaticon-web-download"></i>
              </div>

              <div v-if="displayPassengerListOption === 'SHOW'">
                <p class="p-content-card text-center">
                  The Passenger List and the Pickup Sign for Reservation ID

                  <span class="strong-lg d-block mt-2 mb-2">
                    {{ bookingNumber }}</span
                  >
                  are now available for download by clicking the following
                  buttons:
                </p>
              </div>

              <div v-else>
                <p class="p-content-card text-center">
                  The Pickup Sign for Reservation ID
                  <span class="strong-lg d-block mt-2 mb-2">
                    {{ bookingNumber }}</span
                  >

                  is now available for download by clicking the following
                  button:
                </p>
              </div>

              <div
                class="col-12 text-center pt-2 pb-3"
                v-if="displayPassengerListOption === 'SHOW'"
              >
                <base-button
                  type="outline-neutral "
                  class="min-button mb-0"
                  @click="
                    downloadPassengerList(
                      reservationId,
                      bookingNumber,
                      userReference,
                      userType
                    )
                  "
                >
                  <i class="flaticon-web-download mr-1"></i>
                  Download Passenger List
                </base-button>
              </div>

              <div class="col-12 text-center  pb-3">
                <base-button
                  type="outline-neutral "
                  class="min-button mb-0"
                  @click="
                    downloadPickUpSign(
                      reservationId,
                      bookingNumber,
                      userReference,
                      userType
                    )
                  "
                >
                  <i class="flaticon-web-download mr-1"></i>
                  Download Pickup Sign
                </base-button>
              </div>

              <hr />
              <span class="info-card text-center d-block">
                For assistance
              </span>
              <span class="link ml-0" @click="openChatSuport()">
                Chat with us now
              </span>
            </div>

            <div class="loading mt-3" v-if="responseType === 'WAITING'">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <layoutFooter class="footer-pages"></layoutFooter>
  </div>
</template>
<script>
import Navbarpages from "@/views/Layout/Navbarpages";
import endpoint from "../Commons/Services/index";
import swal from "sweetalert2";
import layoutFooter from "../Layout/ContentFooter";
import axios from "axios";
export default {
  data() {
    return {
      responseType: "INIT",
      pdfType: "",
      reservationId: "",
      userReference: "",
      userType: "",
      voucherType: "",
      supplierName: "",
      bookingNumber: "",
      passengers: 0,
      pickupSign: {
        text: "",
        format: "",
        link: ""
      },
      displayPassengerListOption: "HIDE"
    };
  },
  async mounted() {
    let { id, resourceType } = this.$route.params;
    let {
      userReference,
      userType,
      bookingNumber,
      supplierName,
      passengerList
    } = this.$route.query;
    this.userReference = userReference;
    this.userType = userType;
    this.supplierName = supplierName;
    this.bookingNumber = bookingNumber;
    this.reservationId = id;
    this.displayPassengerListOption = passengerList;
    await this.getReservationById(this.reservationId);
  },
  methods: {
    openChatSuport() {
      if ($zoho) {
        $zoho.salesiq.chat.start();
      }
    },
    async getReservationById(reservationId) {
      try {
        let { data } = await endpoint.reservations.services.getReservation(
          reservationId
        );
        if (data.status) {
          let reservation = data.data;
          this.passengers = reservation.passengers;
          this.pickupSign.text = reservation.pickupSign.text;
          this.pickupSign.format = reservation.pickupSign.format;
          this.pickupSign.link = reservation.pickupSign.link;
        } else {
        }
      } catch (error) {
        console.log(error);
      }
    },
    async downloadPickUpSign(
      reservationId,
      bookingNumber,
      userReference,
      userType
    ) {
      let fileName = `PickUpSign(${bookingNumber})`;
      if (this.pickupSign.format !== "FILE") {
        await this.downloadPDF(
          "pickupSign",
          reservationId,
          userReference,
          userType,
          null,
          fileName
        );
      } else {
        await this.downloadFileByLink(this.pickupSign.link, fileName);
      }
    },
    async downloadPassengerList(
      reservationId,
      bookingNumber,
      userReference,
      userType
    ) {
      let fileName = `PassengerList(${bookingNumber})`;
      await this.downloadPDF(
        "passengerList",
        reservationId,
        userReference,
        userType,
        null,
        fileName
      );
    },
    async downloadPDF(
      pdfType,
      id,
      userReference,
      userType,
      voucherType,
      fileName
    ) {
      try {
        this.responseType = "WAITING";
        let client = { type: userType, _id: userReference };
        let { data } = await endpoint.reservations.services.downloadPDF(
          pdfType,
          id,
          client,
          voucherType
        );
        this.responseType = "SUCCESSFUL";
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${fileName}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        this.responseType = "ERROR";
      }
    },
    async downloadFileByLink(path, fileName) {
      try {
        this.responseType = "WAITING";
        const { data } = await axios.get(path, { responseType: "blob" });
        this.responseType = "SUCCESSFUL";
        const blob = new Blob([data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${fileName}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.log(error);
        this.responseType = "ERROR";
      }
    }
  },
  components: {
    navmenu: Navbarpages,
    swal,
    layoutFooter: layoutFooter
  }
};
</script>
